module.exports = __webpack_public_path__ + "static/img/title(1).6fea392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/title(1).png
// module id = A7cp
// module chunks = 1